export enum UserSocialLinkTypeEnum {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
  TIKTOK = "TIKTOK",
  YOUTUBE = "YOUTUBE",
  TWITTER = "TWITTER"
}
